var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentBlok",style:(_vm.setStyle),attrs:{"id":_vm.id}},[_c('div',{staticClass:"container"},[_c('h2',{style:(_vm.getColors)},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{style:(_vm.getColors),domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }